import { render } from "./paint.vue?vue&type=template&id=a5cf86b4&scoped=true&ts=true"
import script from "./paint.vue?vue&type=script&lang=ts"
export * from "./paint.vue?vue&type=script&lang=ts"

import "./paint.vue?vue&type=style&index=0&id=a5cf86b4&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5cf86b4"]])

export default __exports__